import { Instagram, Linkedin, Facebook, Youtube, Mail, Phone, MapPin, Globe } from "lucide-react";
import { CONTACT } from "@/lib/data";

const quickLinks = ["Home", "About Us", "Services", "Portfolio", "Contact"];
const importantLinks = ["Privacy Policy", "Terms & Conditions", "Disclaimer"];

export default function Footer() {
  return (
    <footer id="contact" data-testid="site-footer" className="bg-[#041047] text-white pt-20 pb-10 px-6 lg:px-10 relative overflow-hidden">
      <div className="blur-blob bg-[#CBBCE0]/15 w-[400px] h-[400px] -bottom-40 -right-40" />

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
        {/* Brand */}
        <div className="lg:col-span-4">
          <a href="#home" className="font-display text-3xl tracking-tight">
            DDigital <span className="italic font-medium">Studios</span>
          </a>
          <p className="mt-5 text-white/70 leading-relaxed max-w-sm">
            We help businesses grow online with result-driven digital marketing strategies.
          </p>
          <div className="flex items-center gap-3 mt-8">
            {[
              { Icon: Instagram, href: CONTACT.socials.instagram, label: "instagram" },
              { Icon: Linkedin, href: CONTACT.socials.linkedin, label: "linkedin" },
              { Icon: Facebook, href: CONTACT.socials.facebook, label: "facebook" },
              { Icon: Youtube, href: CONTACT.socials.youtube, label: "youtube" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                data-testid={`social-${label}`}
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] hover:text-[#1a1200] transition-colors"
                aria-label={label}
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="lg:col-span-2">
          <div className="eyebrow !text-white/50">Quick Links</div>
          <ul className="mt-5 space-y-3">
            {quickLinks.map((l) => (
              <li key={l}>
                <a
                  href={l === "Contact" ? "#contact" : `#${l.toLowerCase().replace(/\s+/g, "")}`}
                  className="text-white/80 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Important Links */}
        <div className="lg:col-span-3">
          <div className="eyebrow !text-white/50">Important</div>
          <ul className="mt-5 space-y-3">
            {importantLinks.map((l) => (
              <li key={l}>
                <a href="#" className="text-white/80 hover:text-[#D4AF37] transition-colors text-sm">
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="lg:col-span-3">
          <div className="eyebrow !text-white/50">Contact</div>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-start gap-3 text-white/80">
              <MapPin className="w-4 h-4 mt-0.5 text-[#D4AF37] flex-shrink-0" />
              {CONTACT.address}
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-[#D4AF37] flex-shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="text-white/80 hover:text-[#D4AF37] transition-colors">
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-[#D4AF37] flex-shrink-0" />
              <a href={`tel:${CONTACT.phone.replace(/\s+/g, "")}`} className="text-white/80 hover:text-[#D4AF37] transition-colors">
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/80">
              <Globe className="w-4 h-4 mt-0.5 text-[#D4AF37] flex-shrink-0" />
              {CONTACT.website}
            </li>
          </ul>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto border-t border-white/10 mt-16 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
        <div>© {new Date().getFullYear()} DDigital Studios. All rights reserved.</div>
        <div>Crafted in Ahmedabad · Built for growth.</div>
      </div>
    </footer>
  );
}
